'use client';

import cn from 'classnames';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import OfferFree from '../../assets/offer/offer-free.png';
import OfferStarter from '../../assets/offer/offer-starter.png';
import OfferEnterprise from '../../assets/offer/offer-enterprise.png';
import styles from './offer-slides.module.scss';


export function OfferSlides () {
    const rootRef = useRef<HTMLDivElement>(null);
    const [ visible, setVisible ] = useState(false);

    useEffect(() => {
        const node = rootRef.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            ([ entry ]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.7 },
        );

        observer.observe(node);

        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ rootRef }
            className={ cn(styles.root, { [styles.visible]: visible }) }
        >
            <Image
                width={ 311 }
                height={ 552 }
                src={ OfferStarter }
                alt="Starter plan"
                className={ styles.slide }
            />

            <Image
                width={ 346 }
                height={ 552 }
                src={ OfferEnterprise }
                alt="Enterprise plan"
                className={ styles.slide }
            />

            <Image
                width={ 312 }
                height={ 552 }
                src={ OfferFree }
                alt="Free plan"
                className={ styles.slide }
            />
        </div>
    );
}
